export default __webpack_public_path__ + "media/src/assets/images/ArrowLeft-f555fd2985a8e03d96b0b78c392275c6.svg";